import Flex from "./styled";

export default Flex;
